/**
 * 将全部历史菜单打成 ZIP：每个菜单一份带文字层的 PDF，文件名为 <人均餐标>-<就餐人数>
 */
import JSZip from 'jszip'
import { downloadBlob } from './menuPdf'
import { buildHistoryFileStem } from './historyFileName'
import { listMenuHistory } from './menuHistory'
import { historyRecordToPdfBlob } from './textPdf'

export async function exportAllHistoryMenus() {
  const items = listMenuHistory()
  if (!items.length) {
    throw new Error('暂无历史菜单可导出')
  }
  const zip = new JSZip()
  const used = new Set()
  for (let i = 0; i < items.length; i += 1) {
    const item = items[i]
    const stem = buildHistoryFileStem(item.perCapita, item.guestCount)
    let fileName = `${stem}.pdf`
    if (used.has(fileName)) {
      fileName = `${stem}-${i + 1}.pdf`
    }
    used.add(fileName)
    const blob = await historyRecordToPdfBlob(item)
    zip.file(fileName, blob, { binary: true })
  }
  const packed = await zip.generateAsync({ type: 'blob' })
  downloadBlob(packed, '历史菜单.zip')
}
